import { FilterSuggestionOrders } from '../app/types';
import { SituationType, StatusGroup } from './payment-status';

export type FilterSuggestionTypes = 'AMOUNT' | 'DURATION' | 'TIME';
export const DEFAULT_PATIENT_ID = '0';
export const YES = 'S';
export const NO = 'N';

export const filterSuggestionOrders = new Map<FilterSuggestionTypes, FilterSuggestionOrders>([
  ['AMOUNT', {
    description: 'tws.label-amount',
    id: 'AMOUNT',
  }],
  ['DURATION', {
    description: 'tws.label-duration',
    id: 'DURATION',
  }],
  ['TIME', {
    description: 'tws.label-time',
    id: 'TIME',
  } ],
]);

export const MAP_PROVIDER_BASE_URL = 'https://www.google.com/maps/embed/v1/place?q=';

export const USERNAME_PREFIX_RESERVED = 'TWS-';

export const PHYSICAL_PERSON_CODE_LENGTH_VALIDATION = 6;
export const USERNAME_MIN_LENGTH_VALIDATION_FORGET_PASSWORD = 6;
export const USERNAME_MIN_LENGTH_VALIDATION = 6;
export const USERNAME_MAX_LENGTH_VALIDATION = 50;

export const BS_CHANGE_USER = 'bs_change_user';
export const BS_ALTERNATIVE_LOGIN_VISIBILITY = 'bs_alternative_login_visibility';
export const BS_REFRESH_FORM_COMPL_PESSOA_FISICA = 'refreshFormComplPessoaFisica';
export const CRYPTOPW_MAX_LENGTH = 16;

export const BS_TASK_LIST_CURRENT_WIZARD_STEP = 'bs_task_list_current_wizard_step';
export const BS_TASK_LIST_VISIBLE_STATE = 'bs_task_list_visible_state';
export const BS_TASK_LIST_REQUEST_ABORTED = 'bs_task_list_request_aborted';
export const BS_TASK_LIST_BLOCK_PROFILE_EDITING = 'bs_task_list_block_profile_editing';

export const CTX_KEY_TASK_LIST_FIRST_STEP_RENDERED_NOT_DONE = 'ctx_key_task_list_first_step_rendered_not_done';
export const CTX_KEY_TASK_LIST_IS_PROCESSING = 'ctx_key_task_list_is_processing';

export const SECURE_IMAGE_EXTENSIONS: ReadonlyArray<string> = ['.jpg', '.jpeg', '.png', '.pdf'];

export const statusPaymentTitleMap = new Map<SituationType, string>([

  [SituationType.OPEN, 'patient.opened'],
  [SituationType.PAID, 'patient.filtered-paid-status-checkbox'],
  [SituationType.CANCELED, 'patient.canceled'],
  [SituationType.TITLE_TRANSFERRED, 'patient.transferred']

]);

export const statusPaymentGroupMap = new Map<StatusGroup, string>([

  [StatusGroup.PAYABLE, 'patient.payable'],
  [StatusGroup.PAID, 'patient.filtered-paid-status-checkbox']

]);

export const BLANK_PAGE = '_blank';
